import type { JSX } from 'react';
import React from 'react';

import { Radios } from '@feathr/components';

import type { TCreativeType } from '../types';
import type { ICreativeTypeOption } from './AddCreativeFlow.hooks';

interface IChooseCreativeTypeContentProps {
  options: ICreativeTypeOption[];
  selectedCreativeType: TCreativeType | undefined;
  onCreativeTypeSelect: (creativeType: TCreativeType) => void;
}

function ChooseCreativeTypeContent({
  options,
  selectedCreativeType,
  onCreativeTypeSelect,
}: Readonly<IChooseCreativeTypeContentProps>): JSX.Element {
  function handleChange(value?: string): void {
    if (value) {
      onCreativeTypeSelect(value as TCreativeType);
    }
  }

  return (
    <Radios
      dataName={'creative-type'}
      layout={'block'}
      onChange={handleChange}
      options={options}
      orientation={'vertical'}
      value={selectedCreativeType ?? ''}
    />
  );
}

export default ChooseCreativeTypeContent;
